import { styled } from '@mui/material';

export const OrdersFilterMenuGiverContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(2),
  minWidth: 380,
  maxWidth: 380,
}));

export const OrdersFilterMenuGiverInputsContainer = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }),
);

export const OrdersFilterMenuGiverActionsContainer = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  }),
);
